import React from 'react';
import { DataGridContextMenu } from "../DataGridContextMenu/DataGridContextMenu.js";
import { DataGridRow } from "../DataGridRow/DataGridRow.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function DataGridRowGroup({
  group,
  isLastGroup,
  isFirstGroup,
  rowDecorator,
  rowAlternating,
  hydratedColumns,
  columnCount,
  onRowClick,
  onRightClick,
  isLastColumnFixed,
  openedRow,
  rowBody,
  hasBody,
  contextMenu,
  focusedRow,
  focusRow,
  closeMenu,
  isOverflowing,
  fullyScrolledLeft
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: group.data.map((data, i, allData) => /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(DataGridRow, {
        index: i,
        rowAlternating: rowAlternating,
        columnCount: columnCount,
        hydratedColumns: hydratedColumns,
        rowData: data,
        rowDecorator: rowDecorator,
        isLast: i === allData.length - 1,
        hasBody: hasBody,
        onRightClick: onRightClick,
        onRowClick: onRowClick,
        hasSeparatorNext: i === allData.length - 1 && !isLastGroup,
        hasSeparator: i === 0 && !isFirstGroup,
        isLastColumnFixed: isLastColumnFixed,
        isOverflowing: isOverflowing,
        fullyScrolledLeft: fullyScrolledLeft
      }), rowBody && data._id === openedRow && /*#__PURE__*/_jsx("div", {
        style: {
          gridColumn: `span ${columnCount}`
        },
        children: rowBody(data, data._id)
      }, `__body__${data._id}`), contextMenu && data._id === focusedRow && /*#__PURE__*/_jsx(DataGridContextMenu, {
        onClickOutside: closeMenu,
        children: contextMenu(data, focusRow)
      })]
    }, data._id))
  });
}